var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "feed-manager-search",
        _vm._g(
          {
            attrs: { tableType: "feeds" },
            on: { search: _vm.handleFeedSearch },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _vm.filteredFeeds.length && !_vm.showLoader
        ? [
            _c(
              "custom-table",
              _vm._g(
                {
                  attrs: {
                    "table-type": "feeds",
                    columns: _vm.columns,
                    records: _vm.filteredFeeds,
                    actions: _vm.actions,
                  },
                  on: {
                    edit: _vm.handleEdit,
                    schedule: _vm.handleSchedule,
                    delete: _vm.handleDelete,
                    clickedRow: function ($event) {
                      return _vm.$emit("clickedRow", $event)
                    },
                  },
                },
                _vm.$listeners
              )
            ),
          ]
        : _c("custom-table-state", {
            attrs: {
              "table-type": "feeds",
              loading: _vm.showLoader,
              state: _vm.emptyStateType,
            },
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }